import { gql } from '@apollo/client';

export const GET_STYLE_VTON_IMAGES = gql`
    query getStyleVtonImages($input: GetStyleVtonImageInput!) {
        getStyleVtonImages(input: $input) {
            userId
            styleId
            url
            poseType
            taffiId
        }
    }
`;
